import { Page } from '@/components/Page';
import { Section } from '@/components/Section';
import { Cell } from '@/components/Cell';
import { Empty } from '@/components/Empty';
import { Spinner } from '@/components/Spinner';
import { useSupabaseQuery, sb } from '@/hooks/useSupabaseQuery';
import { fmtDateTime } from '@/lib/format';
import type { DeltaTracking } from '@/types/domain';

const fmt = (v: number | null): string => (v == null ? '…' : v.toString());

/** Раздел Delta. Цены ask и спот базового актива после Gamma-сработки через 1/10/30 минут. */
export function DeltaPage(): JSX.Element {
  const items = useSupabaseQuery<DeltaTracking[]>(
    () => sb.from('delta_tracking').select('*').order('alert_at', { ascending: false }).limit(100),
    [],
    20_000,
  );

  return (
    <Page title="Delta — постмониторинг">
      <Section
        header="После сработок Gamma"
        footer="Фиксируются цены ask и спот-цена базового актива в момент алерта и через 1, 10 и 30 минут."
      >
        {items.isLoading ? (
          <Spinner />
        ) : !items.data?.length ? (
          <Empty icon="📈" title="Нет записей" />
        ) : (
          items.data.map((d) => (
            <Cell
              key={d.id}
              before="#"
              title={d.symbol}
              subtitle={(
                <>
                  <div>{`bid@alert ${d.bid_at_alert} · ask 1м ${fmt(d.ask_1m)} · 10м ${fmt(d.ask_10m)} · 30м ${fmt(d.ask_30m)}`}</div>
                  <div>{`spot@alert ${fmt(d.underlying_price_at_alert)} · 1м ${fmt(d.underlying_price_1m)} · 10м ${fmt(d.underlying_price_10m)} · 30м ${fmt(d.underlying_price_30m)}`}</div>
                </>
              )}
              after={fmtDateTime(d.alert_at)}
            />
          ))
        )}
      </Section>
    </Page>
  );
}
